import { render, staticRenderFns } from "./osh-calculator.vue?vue&type=template&id=25b6aa8c&scoped=true&lang=pug"
import script from "./osh-calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./osh-calculator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./osh-calculator.vue?vue&type=style&index=0&id=25b6aa8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b6aa8c",
  null
  
)

export default component.exports